import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import watchdog_45global from "/opt/build/repo/middleware/watchdog.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  watchdog_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "cdn-passthrough": () => import("/opt/build/repo/middleware/cdn-passthrough.ts")
}